<template>
  <div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <feedback-widget/>
      <HorizontalTopbar :type="topbar" :width="layoutWidth"/>
      <HorizontalNav/>
      <SubscriptionBar v-if="userIsFree"/>
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">

        <div class="page-content">

          <div class="container-fluid inside-app">
            <SubscriptionBar class="mb-3" v-if="showingBars.length" :bars="showingBars"/>
            <transition name="fade" mode="out-in">
              <slot/>
            </transition>
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->
        <Footer/>
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->
    <RightBar/>
  </div>
</template>
<script>
import HorizontalTopbar from "@/components/horizontal-topbar";
import HorizontalNav from "@/components/horizontal-nav";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";

import {layoutComputed} from "@/state/helpers";
import SubscriptionBar from "../../components/SubscriptionBar";
import FeedbackWidget from "../../components/Feedback/Feedback";

/**
 * Horizontal-layout
 */
export default {
  components: {
    FeedbackWidget,
    SubscriptionBar,
    HorizontalTopbar,
    HorizontalNav,
    Footer,
    RightBar,
  },
  data() {
    return {
      showingBars: []
    };
  },
  computed: {
    ...layoutComputed,
    userIsFree() {
      return this.$auth.user()?.subscription?.is_trial
    }
  },
  created() {
    this.$auth.load().then(() => {
      const user = this.$auth.user()
      if (user.has_past_due_subscription) {
        this.showingBars.push('has_past_due_subscription')
      }
      if (user.has_pending_payment) {
        this.showingBars.push('has_pending_payment')
      }
      if (user.subscription?.trial_ends_at) {
        this.showingBars.push('trial_ends')
      }
    })
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
